import "./sentry";

import "./utils/patchSetTimeout";
import { polyfillUrlCanParse } from "./utils/polyfillUrlCanParse";

polyfillUrlCanParse();

import axios from "axios";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

import "./axios";
import "./echo";
